
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18888.484 -23779.6 14.154 15.199"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_7751","data-name":"Group 7751","transform":"translate(-19635.116 -24042)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3389","d":"M14 21.273H7.25A2.435 2.435 0 0 1 5 18.716v-8.341C5 10 5.17 10 5.545 10h9.785c.375 0 .545 0 .545.375v8.682A2.044 2.044 0 0 1 14 21.273z","data-name":"Path 3389","transform":"translate(743.254 255.727)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_1632","d":"M0 0h12.955","data-name":"Line 1632","transform":"translate(747.231 265.727)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3390","d":"M18.773 4.045a.322.322 0 0 1-.341.341h-4.091A.322.322 0 0 1 14 4.045v-1.7A.322.322 0 0 1 14.341 2h4.091a.322.322 0 0 1 .341.341z","data-name":"Path 3390","transform":"translate(737.322 261)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_1633","d":"M0 0v4.885","data-name":"Line 1633","transform":"translate(750.981 268.795)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_1634","d":"M0 0v4.885","data-name":"Line 1634","transform":"translate(753.708 268.795)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_1635","d":"M0 0v4.885","data-name":"Line 1635","transform":"translate(756.435 268.795)"}})])])
          )
        }
      }
    